import script from "./BaseTemplateItemSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateItemSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateItemSetting.vue?vue&type=style&index=0&id=de7a14f2&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de7a14f2"]])

export default __exports__